import MasterLayout from "../../../masterLayout/MasterLayout";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import { baseUrl } from "../../../helper/urls";
import CustomTable from "../../../components/custom_table/CustomTable";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const AdminReScheduledBookingList = () => {
  const { token } = useSelector((state) => state.auth);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const RescheduledBookings = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(`${baseUrl}/api/reschedule/admin/list`, {
        headers,
      });
      setBookings(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    RescheduledBookings();
  }, []);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("firstName", {
      header: "Counselor Name",
      Cell: (cell) =>
        `${cell.row.original.c_firstName || ""} ${
          cell.row.original.c_lastName || ""
        }`,
    }),
    columnHelper.accessor("c_email", {
      header: "Counselor email",
      size: 30,
      Cell: (cell) => cell.row.original.c_email,
    }),
    columnHelper.accessor("c_phone", {
      header: "Counselor phone",
      size: 30,
      Cell: (cell) => cell.row.original.c_phone,
    }),

    columnHelper.accessor("s_firstName", {
      header: "Student Name",
      Cell: (cell) =>
        `${cell.row.original.s_firstName || ""} ${
          cell.row.original.s_lastName || ""
        }`,
    }),

    columnHelper.accessor("s_email", {
      header: "Student email",
      size: 30,
      Cell: (cell) => cell.row.original.s_email,
    }),
    columnHelper.accessor("s_phone", {
      header: "Student phone",
      size: 30,
      Cell: (cell) => cell.row.original.s_phone,
    }),
    columnHelper.accessor("request_by", {
      header: "Requested By",
      size: 30,
      Cell: (cell) => cell.row.original.request_by,
    }),
    columnHelper.accessor("approved_by", {
      header: "Approved By",
      size: 30,
      Cell: (cell) => cell.row.original.approved_by,
    }),
    columnHelper.accessor("reason", {
      header: "Reason",
      size: 30,
      Cell: (cell) => cell.row.original.reason,
    }),
    // columnHelper.accessor("booking_date", {
    //   header: "Slot Date",
    //   Cell: (cell) => {
    //     const date = cell.row.original?.booking_date;
    //     return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
    //   },
    // }),

    columnHelper.accessor("created_at", {
      header: "Date",
      size: 30,
      Cell: (cell) => {
        const rawDate = cell.row.original?.created_at;
        if (!rawDate) return "N/A";

        const dateObj = new Date(rawDate);
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();

        return `${day}-${month}-${year}`;
      },
    }),
    columnHelper.accessor("reqId", {
      header: "Request ID",
      Cell: (cell) => "DDR000" + cell.row.original?.id || "-",
    }),
  ];
  columns.unshift(
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const id = cell.row.original.id;
        const status = cell.row.original.status;

        const handleApprove = () => {
          Swal.fire({
            html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
            text: "Do you want to approve this reschedule request?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then((result) => {
            if (result.isConfirmed) {
              axios
                .get(`${baseUrl}/api/reschedule/admin/approved/${id}`, {
                  headers: {
                    Authorization: `Bearer ${token}`, // assume token from session
                  },
                })
                .then((res) => {
                  Swal.fire(
                    "Approved!",
                    "Reschedule has been approved.",
                    "success"
                  );
                  RescheduledBookings(); // reload updated data
                })
                .catch((err) => {
                  Swal.fire(
                    "Error!",
                    err.response?.data?.message || "Failed to approve request.",
                    "error"
                  );
                });
            }
          });
        };

        return (
          <Box display="flex" alignItems="center" gap={1}>
            {status == 0 ? (
              <Button
                variant="contained"
                size="small"
                color="error"
                onClick={handleApprove}
                sx={{ textTransform: "none" }}
              >
                Approve
              </Button>
            ) : (
              <span style={{ color: "green" }}>Approved</span>
            )}
          </Box>
        );
      },
    })
  );

  return (
    <MasterLayout>
      <CustomTable columns={columns} data={bookings} loading={loading} />
    </MasterLayout>
  );
};

export default AdminReScheduledBookingList;
